import React, { createContext, useContext } from 'react';
import { getArtistContractCount } from '../api/artistCounts';
import { useArtistAuth } from './ArtistAuthContext';
import { useBadgeQuery } from './BadgeResourceContext';

const ContractCountContext = createContext();

export const ContractCountProvider = ({ children }) => {
  const { artistUser, checking } = useArtistAuth() || {};
  const { data: contractCount, refresh: refreshContractCount } = useBadgeQuery({
    queryKey: ['artist-contract-count'],
    enabled: Boolean(artistUser?.userId ?? artistUser?.id) && !checking,
    visible: Boolean(artistUser?.userId ?? artistUser?.id),
    initialValue: 0,
    queryFn: async () => {
      const data = await getArtistContractCount();
      if (typeof data?.count !== 'number' || !Number.isSafeInteger(data.count) || data.count < 0) {
        throw new Error('Invalid artist contract count');
      }
      return data.count;
    },
  });
  return <ContractCountContext.Provider value={{ contractCount, refreshContractCount }}>{children}</ContractCountContext.Provider>;
};

export const useContractCount = () => useContext(ContractCountContext);
